import { render, staticRenderFns } from "./CarRegistration.vue?vue&type=template&id=1852d89b&"
import script from "./CarRegistration.vue?vue&type=script&lang=js&"
export * from "./CarRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CarRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports